import { graphql, type ResultOf } from 'graphql-schema';

export const DISCOVER_NEIGHBORHOODS = graphql(`
  query DiscoverNeighborhoods($where: neighborhoods_bool_exp!) {
    neighborhoods(where: $where, order_by: { name: asc }) {
      _id
      name
    }
  }
`);

export type DiscoverNeighborhoodsData = ResultOf<typeof DISCOVER_NEIGHBORHOODS>;
